// src/redux/slices/gamesSlice.ts

import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface Game {
  id: string;
  title: string;
  subtitle: string;
  date: string;
  time: string;
  cost: string;
}

interface GamesState {
  games: Game[];
}

const initialState: GamesState = {
  games: [],
};

const gamesSlice = createSlice({
  name: 'games',
  initialState,
  reducers: {
    addGame: (state, action: PayloadAction<Game>) => {
      state.games.push(action.payload);
    },
    setGames: (state, action: PayloadAction<Game[]>) => {
      state.games = action.payload;
    },
  },
});

export const { addGame, setGames } = gamesSlice.actions;
export default gamesSlice.reducer;
